import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Humidity extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
          Humidity
        </h2>
        <p>
          Relative humidity is the measure of how much water is “being held” in the air compared to the maximum amount of water that can be held at that temperature. Once the air becomes too saturated with water, it will form dew or films of water over leaves, which will lead to mold.
        </p>
        <p>
          You’ll want to monitor this with a <a target="_blank" href="https://www.amazon.com/gp/product/B0013BKDO8/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B0013BKDO8&linkCode=as2&tag=blacksquare05-20&linkId=d04fafc94acfc3fea5d747820c4e4154">Thermometer and Humidity Monitor</a><img src="//ir-na.amazon-adsystem.com/e/ir?t=blacksquare05-20&l=am2&o=1&a=B0013BKDO8" width="1" height="1" alt="" className="amazon__pixel" /> and adjust the humidity in your grow space, with each stage of the grow process requiring a drop in the relative humidity. Consult the chart below for optimal relative humidity.
        </p>
        <h3>
          Relative Humidity by growth stage
        </h3>
        <p className="highlight">
          Seedlings and Clones: 70% - 80% 
          <br />
          Vegetative Stage: 40% - 70% 
          <br />
          Flowering Stage: 40% - 50% 
          <br />
          Final weeks of flowering:  30% - 40%.
        </p>
        <p>
          Seedlings and clones need time to develop a root system to intake water. Young plants are solely dependent on getting water through their leaves from the air and this is only possible with a high humidity. Covering them with a plastic bag that’s been sprayed with water is a good way to keep clones humid and happy. 
        </p>
        <p>
          As plants approach harvest, lowering the humidity will force cannabis buds to produce more resin and prevent bud rot.
        </p>
        <p>
          To increase humidity in your grow room you can spray the walls with water, hang the lights higher or put containers with water or wet towels inside the room. To decrease humidity use an extractor fan or a dehumidifier.
        </p>
        <p>
          Even if the humidity is low, it is still important to have fresh air moving around your plants. Small fans blowing over and under the plants canopy will help keep air moving and prevent wet spots on your plants. 
        </p>
        <div className="guide__shopping-list">
          <h3>Shopping List</h3>
          <iframe className="amazon__iframe" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ac&ref=tf_til&ad_type=product_link&tracking_id=blacksquare05-20&marketplace=amazon&region=US&placement=B0013BKDO8&asins=B0013BKDO8&linkId=a48868611462716a014a932ed58d0ecc&show_border=true&link_opens_in_new_window=true&price_color=333333&title_color=0066c0&bg_color=ffffff">
          </iframe>

        </div>
        <GuideButton slugTo="nutrients" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_humidity.js